module.exports = __webpack_public_path__ + "img/1543887425.1407c08b.jpg";